const esES_Translations = {
  mainMenu:{
    hello: 'Hi (es)'
  },
  main:{
    labels:{
      learnMore: 'Conocer más',
      buyNow: 'Compra Ahora',
      get3dps: 'Obtener mi Solucion de Impresion 3D',
      whereToBuy: 'Donde Comprar',
      checkout: 'Checkout',
      checkoutCartNote: 'Tasas, envio y descuentos aplicados en el checkout',
      total: 'Total',
      apply: 'Aplicar',
      emptyCart: 'Vaciar Carrito',
      soldOut: 'Agotado',
      seeCart: 'Ver Carrito',
      addToCart: 'A;adir al Carrito',
      unselectAll: 'Deseleccionar Todos',
      selectAll: 'Seleccionar Todo',
      selectAllInPage: 'Seleccionar Todos en esta Página',
      clearAllFilters: 'Limpiar Todos',
      checkAllFilters: 'Marcar Todos',
      categories: 'Categor`ias',
      continents: {
        asia: 'Asia',
        africa: '`Africa',
        europe: 'Europa',
        oceania: 'Ocean`ia',
        southAmerica: 'Sur Am`erica',
        centralAmerica: 'Centro Am`erica',
        northAmerica: 'Norte Am`erica',
        others: 'Otros'
      }
    }
  }
}